<div class="card border-0 bg-light">
	<div class="card-body d-flex align-items-center gap-3 p-3 p-md-4">
		<fa-duotone-icon icon="building" size="lg" class="text-muted" secondaryOpacity="0.3" />
		<div>
			<div class="fw-semibold">Select an Organization</div>
			<div class="text-muted small">Choose a community from the sidebar to see detailed statistics and management tools.</div>
		</div>
	</div>
</div>
